import React, { useState, Fragment, useRef, useEffect } from "react"
import { useDispatch } from "react-redux"
import { FaCheck, FaTrashAlt } from "react-icons/fa"
import { TbDotsVertical } from "react-icons/tb"
import { useTranslation } from "react-i18next"
import { Dropdown, MenuItem } from "react-bootstrap"

import { incNumberOfOrders } from "@redux"
import { ConfirmationModal, } from "components"
import { confirmOrder, deleteOrder } from "services"
import classes from "./KtOrderNoteCardDropDown.module.scss"

const KtOrderNoteCardDropDown = props => {
  const {
    tableNotConfirmedOrder,
    setTableNotConfirmedOrders
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const [sending, setSending] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false)

  const unmount = useRef(false)

  const handleConfirmOrder = async () => {
    setSending(true)

    try {
      await confirmOrder(tableNotConfirmedOrder._id)

      if (!tableNotConfirmedOrder.isViewed) {
        dispatch(
          incNumberOfOrders("notConfirmed", -1)
        )

        dispatch(
          incNumberOfOrders("pending", 1)
        )
      }

      if (unmount.current) return

      setTableNotConfirmedOrders(prev =>
        prev.filter(o => o._id !== tableNotConfirmedOrder._id)
      )
    } catch (err) {
      console.log(err)

      setSending(false)
    }
  }

  const handleDeleteNotConfirmedOrder = async () => {
    setSending(true)

    try {
      const query =
        tableNotConfirmedOrder.isGuestOrder
          ? { orderId: tableNotConfirmedOrder._id }
          : {}

      await deleteOrder(tableNotConfirmedOrder._id, query)

      !tableNotConfirmedOrder.isViewed &&
        dispatch(
          incNumberOfOrders("notConfirmed", -1)
        )

      if (unmount.current) return

      setTableNotConfirmedOrders(prev =>
        prev.filter(o => o._id !== tableNotConfirmedOrder._id)
      )
    } catch (err) {
      console.log(err)

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <Dropdown
        id="id"
        pullRight={isLtr}
        className={classes["dropdown"]}
      >
        <Dropdown.Toggle
          noCaret
          className={classes["icon"]}
        >
          <TbDotsVertical
            size={20}
          />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <MenuItem
            onClick={() => setShowConfirmationModal(true)}
          >
            <div className={classes["dropdownItem"]}>
              <FaCheck size={14} />

              <span className={classes["dropdownText"]}>
                {t("تایید")}
              </span>
            </div>
          </MenuItem>

          <MenuItem
            onClick={() => setShowDeleteConfirmationModal(true)}
          >
            <div className={classes["dropdownItem"]}>
              <FaTrashAlt
                size={14}
                color="var(--color-danger)"
              />

              <span className={classes["dropdownText"]}>
                {t("حذف")}
              </span>
            </div>
          </MenuItem>
        </Dropdown.Menu>
      </Dropdown>

      <ConfirmationModal
        title={t("آیا_می_خواهید_این_سفارش_را_تایید_کنین")}
        show={showConfirmationModal}
        onConfirm={handleConfirmOrder}
        onHide={() => setShowConfirmationModal(false)}
        loading={sending}
      />

      <ConfirmationModal
        title={t("آیا_می_خواهید_این_سفارش_را_حذف_کنین")}
        show={showDeleteConfirmationModal}
        onConfirm={handleDeleteNotConfirmedOrder}
        onHide={() => setShowDeleteConfirmationModal(false)}
        loading={sending}
      />
    </Fragment>
  )
}

export default KtOrderNoteCardDropDown